/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Step_WarmupInputs */

const en_coach_step_warmup = /** @type {(inputs: Coach_Step_WarmupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm-up`)
};

const de_coach_step_warmup = /** @type {(inputs: Coach_Step_WarmupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen`)
};

/**
* | output |
* | --- |
* | "Warm-up" |
*
* @param {Coach_Step_WarmupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_step_warmup = /** @type {((inputs?: Coach_Step_WarmupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Step_WarmupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_step_warmup(inputs)
	return de_coach_step_warmup(inputs)
});